<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row>
			<b-col md="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Viáticos</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>

								<!--<div v-if="!loading && workProjectsList && workProjectsList.length > 0" class="ml-2">
									<b-button variant="link"
											  class="text-success"
											  @click="exportToExcel"
											  v-b-tooltip.hover title="Descargar listado en Formato Excel">
										<i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
									</b-button>
								</div>-->
							</b-col>
						</b-row>
					</template>
					<b-card-body class="table-responsive">
						<b-table :items="travelExpenses"
								 :fields="travelExpensesTableFields"
								 :busy="travelExpensesLoader"
								 show-empty
								 striped
								 empty-filtered-text="No hay viáticos disponibles"
								 empty-text="No hay viáticos disponibles"
								 head-variant="light">
							<div slot="CreatedOn" slot-scope="item">
								{{ item.item.CreatedOn | dateFormatFull }}
							</div>

							<div slot="TotalUSD" slot-scope="item">
								{{
									item.item.TotalUSD | currency(
										configSymbolUSD, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
										)
								}}
							</div>

							<!--<div slot="TotalCRC" slot-scope="item">
								{{
									item.item.TotalCRC | currency(
										configSymbolCRC, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
										)
								}}
							</div>-->

							<div slot="detail" slot-scope="item">
								<router-link :to="{name: 'TravelExpenseDetail', params: {id: item.item.Id}}">
									Ver
								</router-link>
							</div>

							<template v-slot:table-busy>
								<div class="text-center text-info my-2">
									<b-spinner class="align-middle"></b-spinner>
								</div>
							</template>
						</b-table>
						<nav class="d-flex justify-content-center" v-if="totalRows > perPage">
							<b-pagination
								:total-rows="totalRows"
								:per-page="perPage"
								v-model="currentPage"
								prev-text="<<"
								next-text=">>"
								hide-goto-end-buttons/>
						</nav>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>

		<GoBackComponent></GoBackComponent>
	</div>
</template>

<script>
import AccountDetailComponent from "@/components/AccountDetailComponent";
import GoBackComponent from "@/components/GoBackComponent";
import {mapActions, mapState} from "vuex";

export default {
	name: "TravelExpenseList",
	components: {
		AccountDetailComponent,
		GoBackComponent
	},
	data: function () {
		return {
			perPage: 10,
			currentPage: 1,
			loading: false,
			travelExpenses: [],
			configSeparator: '.',
			configFractionCount: 2,
			configFractionSeparator: ',',
			configSymbolPosition: 'front',
			configSymbolSpacing: false,
			configSymbolUSD: '$',
			configSymbolCRC: '₡',
			travelExpensesTableFields: {
				Name: {
					label: 'Número'
				},
				TotalUSD: {
					label: 'Total $'
				},
				CreatedOn: {
					label: 'F. Creación'
				},
				OpportunityNumber: {
					label: '#Valoración'
				},
				Opportunity: {
					label: 'Valoración'
				},
				detail: {
					label: 'Detalles'
				}
			},
		}
	},
	mounted() {
		if (this.accountSelected !== '') {
			this.loading = true;

			this.getTravelExpensesByAccount()
				.then((travelExpenses) => {
					this.travelExpenses = travelExpenses;
				})
				.catch((err) => {
					this.loading = false;
					console.error(err);
				})
				.finally(() => {
					this.loading = false;
				})

		} else {
			this.$router.push('/accounts/');
		}
	},
	methods: {
		...mapActions([
			'getTravelExpensesByAccount'
		])
	},
	computed: {
		...mapState({
			accountSelected: state => state.accountSelected
		}),
		totalRows: function () {
			return this.travelExpenses.length;
		}
	}
}
</script>

<style scoped>

</style>
